export function isResultsTab(searchParams: URLSearchParams): boolean {
  return searchParams.get('roundingTab') === 'Results'
}

export function isDischargeTab(searchParams: URLSearchParams): boolean {
  return searchParams.get('encounterTab') === 'Discharge'
}

export function isAdmissionTab(searchParams: URLSearchParams): boolean {
  return searchParams.get('encounterTab') === 'Admission'
}

export function isRoundingTab(searchParams: URLSearchParams): boolean {
  return searchParams.get('encounterTab') === 'Rounding'
}
export function isEncounterTab(searchParams: URLSearchParams): boolean {
  return searchParams.get('encounterTab') !== null
}
